










































import { Vue, Component } from "vue-property-decorator";
import { AxiosError } from "axios";
import EditorWithFile from "@/components/EditorWithFile.vue";
import api from "@/getinfo-api";
import { TermCreate as ITermCreate } from "@/api/models/term-create";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomButton from "@/components/form/CustomButton.vue";
//TODO: add editor

@Component({
  components: { CustomButton, EditorWithFile }
})
export default class TaxonomyForm extends Vue {
  body!: string;
  title!: string;
  termType: string = "activity";
  isSavingProcess: boolean = false;

  data() {
    return {
      body: undefined,
      title: undefined
    };
  }

  get apiMethod() {
    let method: any;
    if (this.termType === "activity")
      method = api.ProfessionalActivityTaxonomyApi;
    if (this.termType === "specialty") method = api.SpecialtyTaxonomyApi;
    if (this.termType === "program")
      method = api.ProfessionalProgramTaxonomyApi;
    return method;
  }

  createTerm() {
    this.isSavingProcess = true;
    let params: ITermCreate = {
      title: this.title,
      description: this.body
    };

    this.apiMethod
      .create(params)
      .then(() => {
        this.$router.push({
          name: "ProfessionalActivityTaxonomyList"
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isSavingProcess = false;
      });
  }

  practiceBodyCreatePage(item: string) {
    this.body = item;
  }
}
